import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); setUserMenuOpen(false); }, [location.pathname]);

  const handleLogout = () => { logout(); navigate('/'); };

  const navLinks = [
    { to: '/jobs', label: '🏃 الوظائف' },
    { to: '/services', label: '⚡ الخدمات' },
    { to: '/professionals', label: '👥 المحترفون' },
    { to: '/organizations', label: '🏆 المؤسسات' },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <span className="logo-icon">⚡</span>
            <span className="logo-text">SPORTIX</span>
          </Link>

          <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
            {navLinks.map(link => (
              <li key={link.to}>
                <Link to={link.to} className={location.pathname.startsWith(link.to) ? 'active' : ''}>{link.label}</Link>
              </li>
            ))}
          </ul>

          <div className="navbar-actions">
            {isAuthenticated ? (
              <div className="user-menu-wrapper">
                <button className="user-btn" onClick={() => setUserMenuOpen(!userMenuOpen)}>
                  {user?.avatar ? (
                    <img src={user.avatar} alt={user.full_name} className="avatar avatar-sm" />
                  ) : (
                    <div className="avatar-placeholder avatar-sm" style={{ fontSize: 14 }}>
                      {user?.full_name?.[0]?.toUpperCase()}
                    </div>
                  )}
                  <span className="user-name">{user?.full_name?.split(' ')[0]}</span>
                  <span>▾</span>
                </button>
                {userMenuOpen && (
                  <div className="user-dropdown">
                    <div className="dropdown-header">
                      <div className="fw-700">{user?.full_name}</div>
                      <div className="text-muted text-sm">{user?.email}</div>
                    </div>
                    <div className="dropdown-items">
                      <Link to="/dashboard" className="dropdown-item">📊 لوحة التحكم</Link>
                      <Link to="/profile/edit" className="dropdown-item">⚙️ تعديل الملف</Link>
                      <Link to="/messages" className="dropdown-item">💬 الرسائل</Link>
                      <Link to="/notifications" className="dropdown-item">🔔 الإشعارات</Link>
                      <div className="dropdown-divider" />
                      {user?.user_type === 'organization' && (
                        <Link to="/post-job" className="dropdown-item text-primary">+ نشر وظيفة</Link>
                      )}
                      {user?.user_type === 'individual' && (
                        <Link to="/post-service" className="dropdown-item text-primary">+ عرض خدمة</Link>
                      )}
                      <div className="dropdown-divider" />
                      <button onClick={handleLogout} className="dropdown-item text-error">🚪 تسجيل الخروج</button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="auth-btns">
                <Link to="/auth/login" className="btn btn-ghost btn-sm">دخول</Link>
                <Link to="/auth/register" className="btn btn-primary btn-sm">انضم الآن</Link>
              </div>
            )}
            <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
              <span></span><span></span><span></span>
            </button>
          </div>
        </div>
      </div>
      {userMenuOpen && <div className="overlay" onClick={() => setUserMenuOpen(false)} />}
    </nav>
  );
};

export default Navbar;
